const CONST = {
	BASE_URL_GRAPHQL: process.env.REACT_APP_BASE_URL_GRAPHQL,
};

export default CONST;
